import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './delete.scss';

export default ({ isOpen, toggle, title, content, link, onChangeHandler,actionType }) => {
  let history = useHistory();

  const redirectLink = (link) => {
    toggle(!isOpen)
  }
  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='next-step-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              redirectLink(link)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            <div>
            </div>
            <div className='modal-content'>
              {actionType ==="ACHAccount"?<p>Are you sure to delete the ACH account?</p>:
              <>{actionType ==="bankAcc"?<p>Are you sure to delete the bank account?</p>:
              <p className='my-2 mb-4'>Are you sure to delete the card?</p>}</>}
              
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>           
            <Button
              type='app-green-button submitBtn'
              handleClick={() => {
                toggle(!isOpen)
              }}>
              No
            </Button>

            <Button
              type='app-green-button'
              handleClick={() => {
                onChangeHandler("Yes")
              }}>
              Yes
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
